<div class="relative pb-5">
  <form
    [formGroup]="frm_search"
    class="p-fluid grid">
    <div class="col-12">
      <label for="serial_numbers">Serial numbers (CSV)</label>
      <input
        id="serial_number"
        pInputText
        formControlName="serial_numbers"
        class="w-full" />
    </div>
  </form>

  <p-table
    [value]="assets"
    #dt1
    dataKey="id"
    [loading]="loading"
    [(selection)]="selectedAssets"
    [selectionMode]="'multiple'">
    <ng-template pTemplate="header">
      <tr class="tHead">
        <th>
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th>Serial number</th>
        <th>Asset code</th>
        <th>Prodotto</th>
        <th>Magazzino</th>
        <th>Utilizzo</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-s>
      <tr>
        <td>
          <p-tableCheckbox [value]="s"></p-tableCheckbox>
        </td>
        <td>
          {{ s.serial_number }}
        </td>
        <td>
          {{ s.asset_code || 'N.D.' }}
        </td>
        <td>{{ s.related_product.name }}</td>
        <td>{{ s.related_warehouse?.name || '-' }}</td>
        <td>{{ s | assetUtilizzo }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td
          colspan="6"
          class="text-center py-2">
          Nessun risultato.
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-paginator
    (onPageChange)="onPageChange($event)"
    [first]="frm_search.get('skip')!.value!"
    [rows]="frm_search.get('pageSize')!.value!"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="rowsPerPageOptions"
    currentPageReportTemplate="Risultati {first} - {last} di {totalRecords} totali" />

  <div
    class="fixed bottom-actions right-0 left-0 bottom-0 flex flex-row justify-content-between align-items-center border-round-bottom bg-white">
    <p-button
      (onClick)="ref.close()"
      [text]="true"
      label="Annulla"
      styleClass="butt p-button-outline p-button-secondary"
      [rounded]="true"></p-button>
    <p-button
      icon="pi pi-check"
      (onClick)="onSubmit()"
      styleClass="butt"
      label="Aggiungi"
      [rounded]="true"></p-button>
  </div>
</div>
